/**
 * Diagnosis Service
 * Patient diagnosis tracking and management API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DiagnosisTypeResponseDto { 
    /**
     * Diagnosis type identifier
     */
    id: string;
    /**
     * Collection identifier
     */
    collectionId: string;
    /**
     * Unique slug for the diagnosis type
     */
    slug: string;
    /**
     * Display name of the diagnosis type
     */
    display: string;
    /**
     * Description of the diagnosis type
     */
    description?: string;
    /**
     * Status of the diagnosis type
     */
    status: DiagnosisTypeResponseDto.StatusEnum;
    /**
     * Metadata schema for the diagnosis type
     */
    metadataSchema?: any;
    /**
     * Record schema for the diagnosis type
     */
    recordSchema?: any;
    /**
     * Form identifier associated with the diagnosis type
     */
    formId?: string;
    /**
     * Group identifiers this diagnosis type belongs to
     */
    groupIds?: Array<string>;
}
export namespace DiagnosisTypeResponseDto {
    export type StatusEnum = 'draft' | 'active' | 'inactive';
    export const StatusEnum = {
        Draft: 'draft' as StatusEnum,
        Active: 'active' as StatusEnum,
        Inactive: 'inactive' as StatusEnum
    };
}


